import { ProductAddToCartState } from "@faire/deprecated-retailer-visitor-shared/views/product/cart/useProductAddToCartState";

export const isSelectedProductDifferentThanCart = (
  productAddToCartState: ProductAddToCartState
) => {
  const {
    selectedQuantity,
    productOptionInCart,
    includesTesters,
    isSelectedOpenSizingQtyModified,
    isOpenSizingVariant,
  } = productAddToCartState;
  const isQuantityModified =
    selectedQuantity !== productOptionInCart?.quantity ||
    includesTesters !== !!productOptionInCart?.includes_tester;

  const isProductOptionModified = isOpenSizingVariant
    ? isSelectedOpenSizingQtyModified
    : isQuantityModified;

  return !productOptionInCart || isProductOptionModified;
};
